
import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";

@Component({
  name: "Dashboard",
})
export default class extends Vue {
  get name() {
    return UserModule.name;
  }

  get roles() {
    return UserModule.roles;
  }
  public publicPath = process.env.BASE_URL;
  public checkdisable(urlName) {
    var flag = true;
    this.urlenum.forEach((element) => {
      if (element.urlname == urlName) {
        flag = false;
      }
    });
    return flag;
  }
  private async GotoAbout() {
    this.$router.push(`/about`);
  }
  public clickaction(urlName) {
    if (urlName == null) {
      return;
    }
    var urlpath = "";
    this.urlenum.forEach((element) => {
      if (element.urlname == urlName) {
        urlpath = element.urlpath;
        this.$router.push(urlpath);
        return;
      }
    });
  }
  private listLoading = false;
  private tableColumnList = [
    { prop: "tablecolunm1", propName: "快件收入" },
    { prop: "tablecolunm2", propName: "包笼车操作" },
    { prop: "tablecolunm3", propName: "单据扫描" },
    { prop: "tablecolunm4", propName: "发车到车" },
    { prop: "tablecolunm5", propName: "派件签收" },
    { prop: "tablecolunm6", propName: "配置" },
    { prop: "tablecolunm7", propName: "操作打印" },
    { prop: "tablecolunm8", propName: "帮助" },
    { prop: "tablecolunm9", propName: "文档管理" },
  ];
  // 这里为了简便我就没有调用后台接口获取数据，直接写的假数据
  public showList = [
    {
      tablecolunm1: "取件扫描",
      tablecolunm2: "下车扫描",
      tablecolunm3: "自动化相机申请",
      tablecolunm4: "发车扫描",
      tablecolunm5: "隧道机",
      tablecolunm6: "配置",
      tablecolunm7: "打印管理",
      tablecolunm8: "帮助",
      tablecolunm9: "打开图片路径",
    },
    {
      tablecolunm1: "揽收扫描",
      tablecolunm2: "上车扫描",
      // tablecolunm3: "",
      tablecolunm4: "到车扫描",
      tablecolunm5: "维修发放",
      tablecolunm7: "包签打印",
      tablecolunm9: "查找图片",
    },
    {
      tablecolunm1: "揽发合一",
      tablecolunm2: "六面扫描",
      tablecolunm4: "解车扫描",
      tablecolunm5: "维修报废",
      tablecolunm7: "摆臂分拣条码",
      tablecolunm9: "打开狂扫异常记录",
    },
    {
      tablecolunm1: "粗分扫描",
      tablecolunm2: "单记泡扫描",
      tablecolunm4: "封车扫描",
      tablecolunm7: "进港虚拟包签打印",
      tablecolunm9: "未上传单号记录查询",
      tablecolunm10: "日志查询",
    },
    {
      tablecolunm2:"回流扫描",
      tablecolunm4: "地磅称重",
      tablecolunm7: "进出港包签补打",
    },
  ];
  public urlenum = [
    {
      urlname: "揽发合一",
      urlpath: "/scanforacceptpacketgetonnew/index",
    },
    {
      urlname: "揽收扫描",
      urlpath: "/scanforacceptpacket/index",
    },
    {
      urlname: "下车扫描",
      urlpath: "/scanforoutbound_getoff/index",
    },
    {
      urlname: "自动化相机申请",
      urlpath: "/camera_apply/index",
    },
    {
      urlname: "上车扫描",
      urlpath: "/scanforgetonnew/index",
    },
    {
      urlname: "进出港包签补打",
      urlpath: "/print/reprint",
    },
    {
      urlname: "六面扫描",
      urlpath: "/scanforsixscannew/index",
    },
    {
      urlname: "地磅称重",
      urlpath: "/scanforweighbridgenew/index",
    },
    {
      urlname: "到车扫描",
      urlpath: "/scanforarrivecarnew/index",
    },
    {
      urlname: "解车扫描",
      urlpath: "/scanforresolvecarnew/index",
    },
    {
      urlname: "封车扫描",
      urlpath: "/scanforsealcarnew/index",
    },
    {
      urlname: "发车扫描",
      urlpath: "/scanfordepartnew/index",
    },
    {
      urlname: "单记泡扫描",
      urlpath: "/scanforbubblepackagenew/index",
    },
    {
      urlname: "包签打印",
      urlpath: "/print/packageprintnew",
    },
    {
      urlname: "进港虚拟包签打印",
      urlpath: "/print/inboundvirtualpacketprintnew",
    },
    {
      urlname: "隧道机",
      urlpath: "/rfid/In",
    },
    {
      urlname: "摆臂分拣条码",
      urlpath: "/print/bigbagprintnew",
    },
    {
      urlname: "未上传单号记录查询",
      urlpath: "/FindNoTransCodeStatusnew/index",
    },
    {
      urlname: "日志查询",
      urlpath: "/loginfo/index",
    },
    {
      urlname: "回流扫描",
      urlpath: "/scanforbackflow/index",
    },
    {
      urlname: "粗分扫描",
      urlpath: "/scanforroughsorting/index",
    },
    {
      urlname: "维修发放",
      urlpath: "/scanforrepairandsupply/index",
    },
    {
      urlname: "维修报废",
      urlpath: "/scanfordiscard/index",
    },
    {
      urlname: "帮助",
      urlpath: "/basedatauploadandsearch",
    },
  ];
}
